export const generateUrlFromFile = (file: File | null) => {
  if (!file) {
    return '';
  }

  const url = URL.createObjectURL(file);

  return url;
};
